import Modal from 'react-bootstrap/Modal';
import { HotTable } from '@handsontable/react';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import { Form, ButtonGroup } from 'react-bootstrap';

import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { Typeahead } from 'react-bootstrap-typeahead';

import styles from '../Gayatri.module.css';
import SessionExpiredModal from '../../../utils/SessionExpiredModal';
import { Autocomplete, FormControl, MenuItem, Select, styled, TextField, ToggleButtonGroup, ToggleButton, toggleButtonGroupClasses, Button } from '@mui/material';
import { SnackbarContext } from '../../../App';
import ActionRequiredModal from './ActionRequiredModal';

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    display: 'flex',
    flex: 1,
    width: '100%',
    margin: '0.5vw',
    border: 0,
    borderRadius: theme.shape.borderRadius,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
      {
        marginLeft: -1,

        borderLeft: '1px solid transparent',
      },
}));

export default ({ show, onHide, onRefresh }) => {
  const navigate = useNavigate();
  const auth = useAuth();

  const [
    isSubmitting,
    setIsSubmitting,
  ] = useState(false);

  const [
    selectedTemplate,
    setSelectedTemplate,
  ] = useState();

  const [
    actionRequiredShow,
    setActionRequiredShow,
  ] = useState(false);

  // date selector for create workpaper
  const [
    exactDate,
    setExactDate,
  ] = useState(true);

  const [
    dateType,
    setDateType,
  ] = useState('range');
  const [
    financialYear,
    setFinancialYear,
  ] = useState(false);
  const [
    selectFY,
    setSelectFY,
  ] = useState(false);
  const [
    financialYears,
    setFinancialYears,
  ] = useState([]);

  // submit popup
  const handleReviewDetailsShow = () => setReviewDetailsShow(true);
  const handleReviewDetailsClose = () => setReviewDetailsShow(false);

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, setSessionExpired } = useContext(SnackbarContext);

  const [
    reviewDetailsShow,
    setReviewDetailsShow,
  ] = useState(false);
  const [
    clientId,
    setClientId,
  ] = useState();
  const [
    abn,
    setAbn,
  ] = useState('');
  const [
    clientName,
    setClientName,
  ] = useState('');
  const [
    alternativeName,
    setAlternativeName,
  ] = useState('');
  const [
    fromDate,
    setFromDate,
  ] = useState(`${currentYear - 1}-07-01`);
  const [
    toDate,
    setToDate,
  ] = useState(`${currentYear}-06-30`);
  const [
    financialYearValue,
    setFinancialYearValue,
  ] = useState(currentYear);
  const [
    selectedFile,
    setSelectedFile,
  ] = useState(null);

  const [
    clients,
    setClients,
  ] = useState([]);

  const [
    availableTemplates,
    setAvailableTemplates,
  ] = useState([]);

  const fetchData = () => {
    if (auth.user?.profile.accountant.ssid) {
      console.log('execute');
      fetch(`${window.origin}/api/creator/template`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
      }).then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        }
        return response.json();
      }).then((data) => {
        setAvailableTemplates(data);
        setSelectedTemplate(data[0]?.id);
      }).catch((error) => {
        console.error(error);
      });
    }
  };

  const handleClientSelect = (client) => {
    if (client) {
      setClientId(client.id); // Set clientId when a client is selected
      setAbn(client.ABN);
      setClientName(client.companyName);
    } else {
      setClientId(-1);
    }

    // Only update date fields if they are currently empty
    if (!fromDate) {
      setFromDate('');
    }
    if (!toDate) {
      setToDate('');
    }
    if (!financialYearValue) {
      setFinancialYearValue('');
    }
    setSelectedFile(null);
  };

  useEffect(() => {
    fetchData();

    fetch(`${window.origin}/api/client`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${auth.user?.access_token}`,
      },
    })

      .then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        }
        return response.json();
      })
      .then((data) => {
        console.log('Fetched Clients:', data); // Console log the fetched data
        setClients(data.map(client => ({
          id: client.id, // Mapping client_id to id
          ABN: client.clientabn,
          companyName: client.clientname,
          status: client.status,
        })));
      })
      .catch(error => console.error('Error fetching clients:', error));

    fetch(`${window.origin}/api/creator/financial-years`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${auth.user?.access_token}`,
      },
    })
      .then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        }
        return response.json();
      })
      .then((data) => {
        console.log('Fetched Financial Years:', data);
        setFinancialYears(data.financial_years || []);
      })
      .catch(error => console.error('Error fetching financial years:', error));
  }, [auth.user?.access_token]);

  const handleSubmit = async () => {
    setIsSubmitting(true);

    if (!clientId) {
      setSnackBarMessage('Please select a client to create workpaper');
      setSnackBarShow(true);
      return;
    }

    if (!selectedTemplate) {
      setSnackBarMessage('Please select a template to create workpaper');
      setSnackBarShow(true);
      return;
    }

    const formData = new FormData();
    console.log(financialYearValue);
    formData.append('client_id', clientId); // Assuming you have clientId in your component state or props
    formData.append('start_date', dateType == 'range' ? fromDate : `${Number(financialYearValue) - 1}-07-01`);
    formData.append('end_date', dateType == 'range' ? toDate : `${Number(financialYearValue)}-06-30`);

    formData.append('template_id', selectedTemplate);

    console.log(exactDate ? fromDate : `${financialYearValue}-07-01`);
    console.log(exactDate ? toDate : `${Number(financialYearValue) + 1}-06-30`);
    fetch(`${window.origin}/api/creator/requests`, {
      headers: {
        Authorization: `Bearer ${auth.user?.access_token}`,
      },
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        }
        return response.json();
      })
      .then((data) => {
        console.log('Success:', data);
        handleReviewDetailsClose();
        onRefresh();
        setIsSubmitting(false);
        onHide();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const glassStyle = {
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    borderRadius: '5px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.1)',
    padding: '20px',
  };

  const noBorderStyle = {
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  };

  const footerStyle = {
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
  };

  const updatePeriod = (dates) => {
    const [
      start,
      end,
    ] = dates;
    setFromDate(dayjs(start).format('YYYY-MM-DD'));
    setToDate(dayjs(end).format('YYYY-MM-DD'));
  };

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
  });

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="modal-50w"
      aria-labelledby="example-custom-modal-styling-title"
    >

      <Modal.Body style={{ color: 'rgb(0, 0, 0, 0.8)', padding: '1vw 2vw' }}>
        <h4 style={{ textAlign: 'center', fontSize: '1.3vw', margin: '1vw', fontWeight: '500' }}>Create Workpaper</h4>
        <p style={{ margin: 0, marginBottom: '1vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.7)', textAlign: 'center' }}>Initiate workpaper creation process</p>

        <Form style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>

          {/* period */}
          <Form.Group className="mb-Period" controlId="exampleForm.Period" style={{ margin: '1vw 0vw', height: '50%' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>

              <p style={{ fontSize: '0.85vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)' }}>Period</p>
            </div>

            <div style={{ backgroundColor: 'rgb(255, 255, 255, 0.3)', borderRadius: '0.8vw' }}>

              <div style={{ display: 'flex', textAlign: 'center', padding: '0.2rem', backgroundColor: 'rgb(255, 255, 255, 0.4)', borderRadius: '1vw' }}>
                <StyledToggleButtonGroup
                  value={dateType}
                  exclusive
                  onChange={(event, newValue) => {
                    setDateType(newValue);
                  }}
                >
                  <ToggleButton style={{ color: 'rgb(0, 15, 30, 0.9)' }} value="range">
                    range
                  </ToggleButton>
                  <ToggleButton value="fy">
                    financial year
                  </ToggleButton>
                </StyledToggleButtonGroup>

              </div>
              <div style={{ padding: '1vw' }}>

                {dateType == 'range' && (
                  <ThemeProvider theme={darkTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DateRangePicker']}>
                        <DateRangePicker
                          format="YYYY-MM-DD"
                          value={[
                            dayjs(fromDate),
                            dayjs(toDate),
                          ]}
                          onChange={updatePeriod}
                          startText="Start"
                          endText="End"
                          renderInput={(startProps, endProps) => (
                            <>
                              <Form.Control
                                {...startProps}
                                style={{
                                  width: '10vw',
                                  margin: '0vw auto 0vw 0vw',
                                  color: 'white',
                                  backgroundColor: 'rgba(255, 255, 255, 0.03)',
                                  border: '0.5vw',
                                  padding: '1vw',
                                  fontSize: '1vw',
                                }}
                              />

                              <Form.Control
                                {...endProps}
                                style={{
                                  width: '10vw',
                                  margin: '0vw 0vw 0vw auto',
                                  color: 'white',
                                  backgroundColor: 'rgba(255, 255, 255, 0.03)',
                                  border: 'none',
                                  padding: '1vw',
                                  fontSize: '1vw',
                                }}
                              />
                            </>
                          )}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </ThemeProvider>
                )}

                {dateType == 'fy' && (
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', paddingTop: '8px' }}>
                    {/* Year */}
                    <Form.Select
                      style={{ fontSize: '0.85vw', color: 'rgb(0, 0, 0, 0.8)', fontWeight: '500', width: '100%', margin: '0vw auto', backgroundColor: 'rgba(255, 255, 255, 0.5)', border: 'none', padding: '0.7vw 1vw' }}
                      value={financialYearValue}
                      onChange={e => setFinancialYearValue(e.target.value)}
                    >
                      {
                        [...Array(5)].map((_, index) => {
                          let year = Number(currentYear + 1) - index;
                          return <option key={year} value={year} style={{ color: 'black' }}>{year}</option>;
                        })
                      }
                    </Form.Select>
                  </div>
                )}
              </div>

            </div>

          </Form.Group>

          {/* previous workpaper */}

          <Form.Group className="mb-ClientName" controlId="exampleForm.ClientName" style={{ margin: '1vw 0' }}>
            {/* title */}
            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
              {/* <Form.Label style={{ fontSize: '1.3vw', display: 'flex', fontWeight: '600', marginBottom:'1.5vw' }}>Select Client</Form.Label> */}
              {/* <Form.Label style={{ fontSize: '1vw', fontWeight: '600', marginBottom:'1vw', marginLeft: '0.2vw' }}>Select Client</Form.Label> */}
              <p style={{ fontSize: '0.85vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)' }}>Client</p>
            </div>

            <Autocomplete
              options={clients}
              onChange={(event, newValue) => {
                handleClientSelect(newValue);
              }}
              getOptionDisabled={option =>
                option.status == 'inactive'}
              getOptionLabel={option => option.companyName}
              sx={{ width: '100%' }}
              renderInput={params => <TextField {...params} label="Disabled options" />}
            />

            <p style={{ fontSize: '0.75vw', paddingTop: '1vw', fontWeight: '400', paddingBottom: '0.8vw', paddingLeft: '0.3vw' }}>
              Couldn't find your clients?
              <span onClick={() => { navigate('/mydigitalworkers/gayatri/clients'); }} style={{ fontWeight: '500', cursor: 'pointer' }}>Manage your clients</span>
            </p>

          </Form.Group>

          <FormControl>
            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
              {/* <Form.Label style={{ fontSize: '1.3vw', display: 'flex', fontWeight: '600', marginBottom:'1.5vw' }}>Select Client</Form.Label> */}
              {/* <Form.Label style={{ fontSize: '1vw', fontWeight: '600', marginBottom:'1vw', marginLeft: '0.2vw' }}>Template</Form.Label> */}
              <p style={{ fontSize: '0.85vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)' }}>Template</p>
            </div>
            <Select
              style={{ width: '100%', height: '3vw' }}
              value={selectedTemplate}
              onChange={(event) => { setSelectedTemplate(event.target.value); }}
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {availableTemplates.map(template => (
                <MenuItem value={template.id}>
                  <p style={{ fontSize: '0.8vw', margin: 0 }}>{template.name}</p>
                </MenuItem>
              ))}

            </Select>
          </FormControl>

          <div style={{ textAlign: 'right', height: '8vh', flexDirection: 'row', alignItems: 'center', display: 'flex', marginTop: '2vw' }}>
            <div style={{ flex: 1 }}>
              <Button
                onClick={handleSubmit}
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '100%', marginTop: '1vw' }}
                variant="primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting' : 'Confirm'}
              </Button>
            </div>
          </div>

        </Form>

      </Modal.Body>
      <ActionRequiredModal show={actionRequiredShow} onClose={() => { setActionRequiredShow(false); }} />
    </Modal>
  );
};

